import { component as defineComponent } from 'flightjs';
import URI from 'urijs';

var UserAuthentication = function() {
    this.attributes({
        endpoint: '/accounts/xhr/login',
    });

    this.after('initialize', function() {
        this.on(document, 'uiUserAuthenticationRequested', this.sendAuthenticationRequest);
    });

    this.sendAuthenticationRequest = function(e, data) {
        var xhr = $.ajax({
            url: this.attr.endpoint,
            method: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json',
        });

        xhr.done(
            function(res) {
                this.postlogin(res);
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.trigger('dataUserAuthenticationFailure');
            }.bind(this)
        );
    };

    this.postlogin = function(res) {
        var xhr = $.ajax(this.postLoginURL(res));

        xhr.done(
            function() {
                this.trigger('dataUserAuthenticationSuccess');
            }.bind(this)
        );

        xhr.error(
            function() {
                this.trigger('dataUserAuthenticationFailure');
            }.bind(this)
        );
    };

    this.postLoginURL = function(res) {
        var payload = new URI(res.target).segment(-1);

        return '/postlogin/xhr/' + payload;
    };
};

export default defineComponent(UserAuthentication);



// WEBPACK FOOTER //
// ./src/web/js/launch/data/user-authentication.js